<template>

  <v-container>

    <h1 class="py-10">Home</h1>

    content

    

  </v-container>

</template>

<script>

import { mapGetters } from "vuex";

export default {
  name: "Home",

  computed: {

    ...mapGetters({
      user: 'user/current'
    })

  },

  watch: {
    user() {
      
      console.log('LOGHIERO');

      if(this.user.loggedin){
        console.log('Nais hoor LOGGEDIN');
      }else{
        console.log('Nais hoor LOGOUT');
      }

    },
  },
  
  data () {
    return {
      contest: 'loading'
    }
  },
  methods: {

    get_locales(locales){

      return Object.keys(locales) ;

    }

  },
  created() {

    console.log('NODE_ENV');

  }

};
</script>
